import Button from '@/components/atoms/Button'
import Modal from '@/components/atoms/Modal'
import { useAppSelector } from '@/store/hooks'
import { useState } from 'react'
import ReactPlayer from 'react-player'

import './style.css'

interface EthicsPolicyProps {
	disabledOnClose?: boolean
}

export function WelcomeVideo({ disabledOnClose }: EthicsPolicyProps) {
	const {
		matriculate: { classSelect },
		modal: { modalInfo },
	} = useAppSelector((state) => state)

	const [blocked, setBlocked] = useState(true)

	const formTypeMapping: { [key: string]: number } = {
		0: 1009964723, // video generico
		1: 947426974, // video de inglês
	}

	const arrayTypeform = classSelect?.curso_id
		? formTypeMapping[classSelect?.curso_id]
		: formTypeMapping[0]

	return (
		<Modal
			name='onboardingWelcomeVideoModal'
			disabledOnClose={disabledOnClose}
			className='px-0 md:px-0 md:py-4 max-w-[1020px] dark:bg-white/95 rounded'
		>
			<div className='flex flex-col gap-4'>
				<div className='flex flex-col w-full h-[60vh]'>
					<ReactPlayer
						url={`https://player.vimeo.com/video/${arrayTypeform || '1009964723'}?dnt=1`}
						controls
						width='100%'
						height='100%'
						onEnded={() => setBlocked(false)}
						className='w-full h-[500px] bg-white/10'
						id='welcome-style'
					/>
				</div>
				<div className='flex justify-end px-4'>
					<Button
						className='w-full max-w-[150px] md:max-w-[200px] rounded uppercase px-2 h-[42px]'
						onClick={() => modalInfo()}
						disabled={blocked}
					>
						Continuar
					</Button>
				</div>
			</div>
		</Modal>
	)
}
